import React, { useEffect, useState, useContext, useRef } from "react";
import dynamic from "next/dynamic";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { styled, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import Button from "@acko-tech/building-blocks.ui.button-old";
import ModalLazyLoad from "@components/common/mobile/modal";

import {
  mmvUseEffectHook,
  useMMVData,
  useVehicleData
} from "@components/car/journey/common/useCustomHooks";
import {
  getFuelType,
  getVariantType,
  handleModal,
  handleMmvClickOptions,
  fireCloseModalR2d2,
  getVehicleById
} from "@components/common/carJourney/mmvCard/mmv-utils";
import { handleVehicleDetails } from "@components/newCar/journey/common/utils";

import removeModalBackgroundScroll from "utils/removeModalBackgroundScroll";

// import MobileModal from "@components/common/mobile/modal";
// import DesktopModal from "@components/common/desktop/modal";
import {
  SelectedValueInterface,
  ChosenVariantInterface,
  ChosenCarInterface
} from "@components/car/journey/types.d";
import {
  // externalCngValueError,
  // externalCngValueEntered,
  // externalCngNoSelected,
  // externalCngYesSelected,
  commericalCarSelected,
  privateCarSelected,
  // variantConfirmed,
  carPurchaseDropdownClicked,
  carPurchaseQuestionLoaded,
  carPurchaseAnswerSelected,
  // commericalCarYesSelected,
  // commericalCarNoSelected,
  findMakeModelClicked,
  selectFuelType,
  selectVariantLoaded,
  selectVariant,
  selectMakeModelVariantScreenLoaded,
  vehicleDetailsScreenLoaded,
  vehicleTypeSelected
} from "@analytics/newCar/actions/landing";

import MmvDetails from "@components/common/carJourney/mmvCardV2/mobile/mmvDetails";
import {
  StickyContainer,
  $primaryColorsV2
} from "@components/car/journey/mobile/styles";

const MmvOptions = dynamic(
  import("@components/common/carJourney/mmvCardV2/mobile/mmvOptions"),
  {
    ssr: true
  }
);

import QuestionsCard from "@components/common/mobile/questionCard";

import InputField from "@components/common/mobile/inputField";

import Context from "@components/useContext/context";

import { tapBtnIsCommercial } from "segments/eventActions/common/prequoteModule";
import {
  newCarDeliveryDateEntered,
  tapBtnEnterNewCarDetailsCta,
  viewPageEnterNewCarDetails,
  viewPageEnterNewCarDetailsMounted
} from "segments/eventActions/newCar/prequoteModule";
import { ModalDesktop, ModalMobile } from "@acko-tech/building-blocks.ui.modal";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {
  AnimateWrapper,
  duration
} from "@components/common/carJourney/mmvCard/desktop/styles";
import StickyFooter from "@components/common/desktop/stickyFooter";
import { ModalHeading } from "./styles";
import Heading from "@components/common/standAlone/pageHeading/PageHeading";

import InputModal from "@components/common/desktop/inputModal";
import StyledChevronDown from "@components/common/standAlone/downArrow";
import FIELD_ERROR_MESSAGE from "@utils/errorMessages";
import { useRunOnceHook } from "@components/common/custom-hooks";

const ExternalCngCommercial = dynamic(() =>
  import("@components/newCar/journey/common/vehicleDetails/ExternalCngCard")
);

const StyledButton = styled(Button)`
  height: 48px;
  font-size: 16px;
`;

const HeadingContainer = styled(Text)`
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #040222;
`;

const headingText = (type: string): string => {
  switch (type) {
    case "make":
      return "Which car are you planning to buy";
    case "model":
      return "Select your car's fuel type";
    case "variant":
      return "Select your car's \nvariant type";
    default:
      return "";
  }
};

interface ComponentProps {
  question: string;
  handleClick: Function;
  vehicles: VehicleProps[];
  popularVehicles: VehicleProps[];
  selectedValue: SelectedValueInterface;
  handleToast: Function;
  allFuelTypes: object;
  track: Function;
  analytics: any;
  carNumber: string;
  mmvSuccess: boolean;
  yearOptions: any;
  monthOptions: any;
  externalCNGKit: string;
  selectedRegistrationYear?: any;
  selectedRegistrationMonth?: any;
  carType?: string;
  mobileNumber?: string | null;
  proposalSuccess?: boolean;
  showLoader?: boolean;
  tentativeDateOptions?: any;
  selectedTentativePurchaseDate?: any;
  showModal: boolean;
  setShowModal: (val: boolean) => void;
}

interface VehicleProps {
  id: number;
  name: string;
  logo: string;
}

export default function VehicleDetails({
  handleClick,
  popularVehicles,
  vehicles,
  selectedValue,
  handleToast,
  allFuelTypes,
  carNumber,
  carType,
  mmvSuccess,
  // externalCNGKit,
  // mobileNumber,
  tentativeDateOptions,
  selectedTentativePurchaseDate,
  question,
  showModal,
  setShowModal
}: ComponentProps): JSX.Element {
  const dispatch = useDispatch();
  const router = useRouter();

  let tentativeRef = useRef();

  // const { externalCNGKitAmount } = useSelector(
  //   ({ proposalDataReducer }: any) => {
  //     return {
  //       externalCNGKitAmount: proposalDataReducer?.data?.externalCNGKitAmount
  //     };
  //   }
  // );

  mmvUseEffectHook({ carNumber, selectedValue });
  useMMVData({ mmvSuccess, dispatch });
  const [modalType, setModalType] = useState("");
  const [error, toggleError] = useState(false);
  const { isDesktop } = useContext(Context);
  const chosenCarInitState: ChosenCarInterface = {
    id: "",
    image: "",
    name: "",
    variants: []
  };
  const chosenVariantInitState: ChosenVariantInterface = {
    id: "",
    name: "",
    fuel_type: "", // eslint-disable-line
    cc: ""
  };

  const [chosenCar, setChosenCar] = useState(
    selectedValue.make || chosenCarInitState
  );
  const [chosenModel, setChosenModel] = useState(selectedValue.model || "");
  const [chosenVariant, setChosenVariant] = useState(
    selectedValue.variant || chosenVariantInitState
  );

  const [tentativeDate, setTentativeDate] = useState(
    tentativeRef?.current || selectedTentativePurchaseDate?.value || ""
  );

  const vehicleDetails = {
    fuel_type: chosenModel,
    vehicle_make: chosenCar?.name.split(" ")[0],
    vehicle_model: chosenCar?.name
      .split(" ")
      .slice(1)
      .join(" "),
    vehicle_variant: chosenVariant?.name
  };

  // const validExternalCNGKitAmount =
  //   externalCNGKitAmount && externalCNGKitAmount !== "0"
  //     ? externalCNGKitAmount
  //     : "";

  // const [isValidCNGValue, setIsValidCNGValue] = useState(true);
  // const [isCNGValueTyped, setIsCNGValueTyped] = useState(false);

  // const [externalCNG, setExternalCNG] = useState({
  //   value: externalCNGKit || "0",
  //   displayValue: validExternalCNGKitAmount ? "Yes" : "No"
  // });

  const [isCommercial, setIsCommercial] = useState({
    value: carType || "0",
    displayValue: "No"
  });

  // const [externalCNGValue, setExternalCNGValue] = useState(
  //   validExternalCNGKitAmount || ""
  // );
  const [tentativeModal, setShowTentativeModal] = useState(false);
  // const [showModal, setShowModal] = useState(false);

  // useEffect(() => {
  //   console.log("TENTATIVE HERE");
  //   if (selectedTentativePurchaseDate?.value)
  //     setTentativeDate(selectedTentativePurchaseDate?.value);
  // }, [selectedTentativePurchaseDate]);

  useRunOnceHook({
    hookCondition: true,
    callback: () => {
      dispatch(viewPageEnterNewCarDetailsMounted({}));
    }
  });

  useVehicleData({
    make: selectedValue.make,
    variant: selectedValue.variant,
    model: selectedValue.model,
    setMake: setChosenCar,
    setModel: setChosenModel,
    setVariant: setChosenVariant
  });

  useEffect(() => {
    if (mmvSuccess) {
      dispatch(carPurchaseQuestionLoaded({}));
      dispatch(selectMakeModelVariantScreenLoaded({}));
      dispatch(vehicleDetailsScreenLoaded({}));
      dispatch(viewPageEnterNewCarDetails({}));
    }
  }, [mmvSuccess]);

  const { vehicle_id } = router.query;
  useEffect(() => {
    if (vehicle_id && vehicles && vehicles.length > 0 && !chosenCar.name) {
      const vehicleData = getVehicleById(vehicles, vehicle_id as string);

      if (vehicleData) {
        setChosenCar(vehicleData);

        // Get available fuel types for this vehicle
        const availableFuelTypes = getFuelType({
          allFuelTypes,
          chosenCar: vehicleData
        });

        if (availableFuelTypes.length === 1) {
          // Only one fuel type available, auto-select it
          const singleFuelType = availableFuelTypes[0].name;
          setChosenModel(singleFuelType);

          // Get variants for the auto-selected fuel type
          const availableVariants = getVariantType({
            allFuelTypes,
            chosenCar: vehicleData,
            chosenModel: singleFuelType
          });

          if (availableVariants.length === 1) {
            // Only one variant available, auto-select it and skip to delivery date
            setChosenVariant(availableVariants[0]);
            setShowModal(false);
            setShowTentativeModal(true);
          } else if (availableVariants.length > 1) {
            // Multiple variants, show variant selection modal
            setChosenVariant(chosenVariantInitState);
            setShowModal(true);
            handleModal({
              type: "variant",
              setModalType,
              chosenCar: vehicleData,
              chosenModel: singleFuelType,
              handleToast
            });
          }
        } else {
          // Multiple fuel types, show fuel type selection modal
          setChosenModel("");
          setChosenVariant(chosenVariantInitState);
          setShowModal(true);
          handleModal({
            type: "model",
            setModalType,
            chosenCar: vehicleData,
            chosenModel: "",
            handleToast
          });
        }
      }
    }
  }, [vehicles, vehicle_id, chosenCar.name]);

  // screenLoadR2d2Events({
  //   commercialOrPrivateScreenLoaded,
  //   registrationYearScreenLoaded,
  //   registrationMonthScreenLoaded,
  //   dispatch
  // });

  const fuelType = getFuelType({ allFuelTypes, chosenCar });

  const variantTypes = getVariantType({ allFuelTypes, chosenCar, chosenModel });

  // useEffect(() => {
  //   if (externalCNG?.value === "0") {
  //     if (!isValidCNGValue) setIsValidCNGValue(true);
  //     if (isCNGValueTyped) setIsCNGValueTyped(false);
  //   } else {
  //     // reset value if the input is not a number
  //     if (isNaN(Number(externalCNGValue))) {
  //       setExternalCNGValue("");
  //     }
  //     if (
  //       (!externalCNGValue ||
  //         isNaN(Number(externalCNGValue)) ||
  //         Number(externalCNGValue) <= 0 ||
  //         Number(externalCNGValue) > 50000) &&
  //       isValidCNGValue
  //     ) {
  //       setIsValidCNGValue(false);
  //     } else if (
  //       Number(externalCNGValue) > 0 &&
  //       Number(externalCNGValue) <= 50000 &&
  //       !isValidCNGValue
  //     ) {
  //       setIsValidCNGValue(true);
  //     }
  //   }
  // }, [externalCNGValue, externalCNG]);

  function handleSubmit() {
    /* removed submitR2d2Event this event because this is fired on mobile number screen in old flow
    so will be fired on user details screen in new flow as there we colled mobile number */

    // const submitR2d2Event = variantConfirmed;
    // dispatch(
    //   submitR2d2Event({
    //     edata: {
    //       fuel_type: chosenModel,
    //       vehicle_make_model: chosenCar?.name,
    //       registration_number: carNumber,
    //       phone: mobileNumber
    //     },
    //     odata: {
    //       phone: mobileNumber
    //     }
    //   })
    // );
    dispatch(
      tapBtnEnterNewCarDetailsCta({
        ...vehicleDetails,
        vehicle_variant: chosenVariant?.name,
        is_commercial: !!Number(isCommercial.value),
        delivery_date: tentativeDate
      })
    );

    handleVehicleDetails({
      chosenCar,
      chosenModel,
      chosenVariant,
      isCommercial: !!Number(isCommercial.value),
      handleClick,
      tentativeDate,
      toggleError,
      dispatch
    });
  }

  removeModalBackgroundScroll({ showModal: modalType || tentativeModal });

  const Modal = isDesktop ? ModalDesktop : ModalMobile;

  const tentativePurchaseDate = () => {
    return (
      <Flex justifyContent="center" flexDirection="column">
        <QuestionsCard
          options={[]}
          fullWidthOptions={tentativeDateOptions}
          handleClick={item => {
            setTentativeDate(item.name);
            tentativeRef.current = item.name;
            setModalType("");
            setShowTentativeModal(false);
            dispatch(
              carPurchaseAnswerSelected({
                edata: {
                  purchase_date: item?.analyticsValue,
                  tentativePurchaseDate: item?.value
                }
              })
            );
            dispatch(
              newCarDeliveryDateEntered({
                ...vehicleDetails,
                vehicle_variant: chosenVariant?.name,
                is_commercial: !!Number(isCommercial.value),
                delivery_date: item?.value
              })
            );
          }}
          selectedValue={tentativeDate}
          question=""
          cardStyles={{ padding: "0px" }}
        />
      </Flex>
    );
  };

  const showDeliveryDateModal = variantValue => {
    setChosenVariant(variantValue);
    setShowModal(false);
    setShowTentativeModal(true);
  };

  const shouldShowMMVOptions = () => {
    const component = (
      <InputModal>
        <MmvOptions
          handleClick={options => {
            const { value, type, searchText } = options;
            if (type === "variant") {
              showDeliveryDateModal(value);
            }
            handleMmvClickOptions({
              value,
              type,
              searchText,
              allFuelTypes,
              modalType,
              chosenCar,
              chosenModel,
              setChosenCar,
              setChosenModel,
              chosenVariantInitState,
              setChosenVariant,
              setModalType,
              popularVehicles,
              dispatch
            });
          }}
          queryType={modalType}
          fuelType={fuelType}
          popularVehicles={popularVehicles}
          vehicles={vehicles}
          variantType={variantTypes}
          // showFeedBack={true}
          // viewPort="25vh"
          // maxHeight="100%"
          // track={track}
          // analytics={analytics}
        />
      </InputModal>
    );
    switch (modalType) {
      case "make":
        return component;
      case "model":
        return component;
      case "variant":
        return component;
      default:
        return "";
    }
  };
  return (
    <>
      <Heading text={question} marginBottom={"2rem"} />
      <Flex
        flexDirection="column"
        style={{ gap: "2rem", width: isDesktop ? "84%" : "100%" }}
      >
        <MmvDetails
          name="mmv"
          handleClick={(e: any) => {
            dispatch(findMakeModelClicked({}));
            setShowModal(true);
            e.stopPropagation();
            return handleModal({
              type: "make",
              setModalType,
              chosenCar,
              chosenModel,
              handleToast
            });
          }}
          key="make"
          icon="car-icon"
          selectedValue={chosenCar.name}
          error={!!(chosenCar.name === "" && error)}
        >
          {"Select make and model"}
        </MmvDetails>

        {/* {showModal && shouldShowMMVOptions()} */}

        {isDesktop && (
          <div style={{ marginTop: "-1.1rem" }}>
            <TransitionGroup component={null}>
              {modalType === "make" && showModal && (
                <CSSTransition
                  timeout={duration}
                  classNames="dropdown-transition"
                >
                  <AnimateWrapper>
                    {modalType === "make" && shouldShowMMVOptions()}
                  </AnimateWrapper>
                </CSSTransition>
              )}
            </TransitionGroup>
          </div>
        )}
        <MmvDetails
          name="fuelType"
          handleClick={(e: any) => {
            dispatch(selectFuelType({}));
            setShowModal(true);
            e.stopPropagation();
            handleModal({
              type: "model",
              setModalType,
              chosenCar,
              chosenModel,
              handleToast
            });
          }}
          key="model"
          icon="fuel-pump"
          selectedValue={chosenModel}
          error={!!(chosenModel === "" && error)}
        >
          Fuel type
        </MmvDetails>
        {isDesktop && (
          <div style={{ marginTop: "-1.1rem" }}>
            <TransitionGroup component={null}>
              {modalType === "model" && showModal && (
                <CSSTransition
                  timeout={duration}
                  classNames="dropdown-transition"
                >
                  <AnimateWrapper>
                    {modalType === "model" && shouldShowMMVOptions()}
                  </AnimateWrapper>
                </CSSTransition>
              )}
            </TransitionGroup>
          </div>
        )}
        {/* {isDesktop && modalType === "model" && shouldShowMMVOptions()} */}
        <MmvDetails
          name="variant"
          handleClick={(e: any) => {
            dispatch(selectVariantLoaded({}));
            dispatch(selectVariant({}));
            e.stopPropagation();
            setShowModal(true);
            handleModal({
              type: "variant",
              setModalType,
              chosenCar,
              chosenModel,
              handleToast
            });
          }}
          key="variant"
          icon="dots-line"
          selectedValue={chosenVariant.name}
          error={!!(chosenVariant.name === "" && error)}
        >
          Variant
        </MmvDetails>
        {isDesktop && (
          <div style={{ marginTop: "-1.1rem" }}>
            <TransitionGroup component={null}>
              {modalType === "variant" && showModal && (
                <CSSTransition
                  timeout={duration}
                  classNames="dropdown-transition"
                >
                  <AnimateWrapper>
                    {modalType === "variant" && shouldShowMMVOptions()}
                  </AnimateWrapper>
                </CSSTransition>
              )}
            </TransitionGroup>
          </div>
        )}
        {/* Temporary fix for dispotioned iocn is to add relative
         div as a parent for input field and instead fo passing Icon as props, add Icon as component beneath  */}
        <InputField
          name="purchaseDate"
          style={{ width: "100px" }}
          placeholder={"Car delivery date"}
          value={tentativeDate || ""}
          inputStyles={{
            // border: error && !tentativeDate && `1px solid ${$error}`,
            caretColor: "transparent",
            height: isDesktop ? "48px" : ""
          }}
          // hideLabelText={!tentativeDate}
          handleClick={() => {
            dispatch(carPurchaseDropdownClicked({}));
            setShowTentativeModal(true);
          }}
          showError={error && !tentativeDate}
          errors={{ purchaseDate: FIELD_ERROR_MESSAGE.purchaseDate.required }}
          inputContainerStyles={{ margin: "0px", height: "50px" }}
          touched={{}}
          readOnly
          Icon={
            <StyledChevronDown
              onClick={() => {
                dispatch(carPurchaseDropdownClicked({}));
                setShowTentativeModal(true);
              }}
            />
          }
        />

        <ExternalCngCommercial
          isCommercial={isCommercial}
          handleCommercialSubmit={item => {
            setIsCommercial(item);
            const ekind =
              item?.displayValue === "No"
                ? privateCarSelected
                : commericalCarSelected;

            dispatch(ekind({}));
            dispatch(
              vehicleTypeSelected({
                edata: {
                  vehilce_type:
                    item?.displayValue === "Yes" ? "commercial" : "private"
                }
              })
            );
            dispatch(
              tapBtnIsCommercial({
                ...vehicleDetails,
                is_commercial: item?.displayValue === "Yes",
                is_external_cng: false,
                delivery_date: tentativeDate
              })
            );
          }}
        />
      </Flex>
      <Flex mt="20px" mb="1em" flexDirection="column" alignItems="center">
        {isDesktop ? (
          <StickyContainer left="-18px">
            <StickyFooter
              ctaText="Continue"
              clickHandler={handleSubmit}
              price=""
              hidePriceSection
            />
          </StickyContainer>
        ) : (
          <StickyContainer>
            <StyledButton
              styles={{
                colorScheme: $primaryColorsV2
              }}
              fluid
              onClick={handleSubmit}
            >
              Continue
            </StyledButton>
          </StickyContainer>
        )}
      </Flex>
      <ModalLazyLoad
        header={
          <div className="w-full">
            <HeadingContainer>{headingText(modalType)}</HeadingContainer>
          </div>
        }
        show={!isDesktop && modalType !== ""}
        onHide={() => {
          fireCloseModalR2d2({ modalType, dispatch });
          setModalType("");
        }}
        variant={modalType !== "model" ? `large` : ``}
        styles={{
          padding: "32px 20px 20px",
          overflow: "hidden",
          borderRadius: "24px 24px 0px 0px"
        }}
      >
        <MmvOptions
          handleClick={({ value, type, searchText }) => {
            if (type === "variant") {
              showDeliveryDateModal(value);
            }
            handleMmvClickOptions({
              value,
              type,
              searchText,
              allFuelTypes,
              modalType,
              chosenCar,
              chosenModel,
              setChosenCar,
              setChosenModel,
              chosenVariantInitState,
              setChosenVariant,
              setModalType,
              popularVehicles,
              dispatch
            });
          }}
          queryType={modalType}
          fuelType={fuelType}
          popularVehicles={popularVehicles}
          vehicles={vehicles}
          variantType={variantTypes}
          // showFeedBack={true}
          // viewPort="25vh"
          // maxHeight="100%"
        />
      </ModalLazyLoad>

      <Modal
        show={tentativeModal}
        onHide={() => {
          setShowTentativeModal(false);
        }}
        urlhash=""
        minWidth="617px"
        showOverlayBackground
        wrapperStyles={{ minHeight: "275px" }}
        padding={isDesktop ? "40px 150px" : "30px 30px 10px"}
        header={<ModalHeading>Car delivery date</ModalHeading>}
        closeButtonStyles={isDesktop ? { right: "-30%" } : {}}
      >
        {tentativePurchaseDate()}
      </Modal>
    </>
  );
}
